<micro-lookup domain="mail2sms" obj="mail2SmsPostmasters" url="/mail2sms/mail2SmsPostmasters" [key]="postmasterId" [link]="link"></micro-lookup>
